var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Теги заявок на подбор",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      fields: _vm.fields,
      "route-create": "RecruitTagAdd",
      "route-edit": "RecruitTagEdit",
      "route-view": "RecruitTagView",
      "route-path": "/recruit_tags",
      "can-edit": _vm.canEditRecruitTagCatalogs()
    },
    scopedSlots: _vm._u([
      {
        key: "name-tag",
        fn: function(ref) {
          var item = ref.item
          return [
            _c(
              "b-badge",
              {
                staticClass: "px-2 py-1",
                style: _vm.getBadgeStyle(item.color),
                attrs: { pill: "" }
              },
              [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77f4763a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77f4763a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/RecruitTags/RecruitTags.vue
// module id = null
// module chunks = 